import React, { Component } from 'react'
import IconAnnouncement from '../../images/megaphone.svg'
import Link from 'gatsby-link'

export default class Announcement extends Component {
  render() {
    return (
      <div className="announcement">
        <div className="a-icon">
          <img src={IconAnnouncement} />
        </div>
        <div className="a-info">
          <p>
            Get your copy of <Link to="/hands-on-gatsbyjs"><span>"Hands on Gatsbyjs"</span></Link> and learn how to
            supercharge your websites, embrace JAMStack and add microservices to
            implement authenticacion, create shopping carts and more.{' '}
            <Link to="/hands-on-gatsbyjs" className="a-animation">get your copy now</Link>
          </p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Announcement/Announcement.jsx